/* eslint-disable camelcase */
import { type UseQueryResult, useQuery } from 'react-query';
import {
  TaxItemApprovalService,
  type PagedResultDto_GetTaxItemDto,
} from '../../services/wealthlane-tax-services';
import { type TableParamsType } from '../../types/common';

const useGetTaxSetupApproverList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
): UseQueryResult<PagedResultDto_GetTaxItemDto | undefined, unknown> => {
  const { taxPeriodId, taxApprovalStatusId, filter, sorting, skipCount, maxResultCount } =
    tableInfo;
  const taxSetupApproverList = useQuery(['getTaxSetupApproverList', tableInfo], async () => {
    return await handleRequest(
      TaxItemApprovalService.getApiTaxApiAppTaxItemApprovalTaxItemList(
        taxPeriodId,
        taxApprovalStatusId,
        filter,
        sorting,
        skipCount,
        maxResultCount
      )
    );
  });

  return taxSetupApproverList;
};

export default useGetTaxSetupApproverList;
